import styled, { css, keyframes } from 'styled-components/macro';

const animationFirstLine = keyframes`
    0% {
        left: -100%;
        width: 100%;
    }
    100% {
        left: 100%;
        width: 10%;
    }
`;

const animationSecondLine = keyframes`
    0% {
        left: -150%;
        width: 100%;
    }
    100% {
        left: 100%;
        width: 10%;
    }
`;
interface LoaderProps {
    absolute: boolean;
    position: 'top' | 'bottom';
}
const Loader = styled.div.attrs({})<LoaderProps>`
    position: relative;
    width: 100%;
    height: 4px;
    overflow: hidden;

    ${(props) =>
        props.absolute &&
        css`
            position: absolute;
            z-index: 300;
            left: 0;
            ${props.position === 'top' ? 'top: 0;' : ''}
            ${props.position === 'bottom' ? 'bottom: 0;' : ''}
        `}

    &:before {
        content: '';
        position: absolute;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.brand};
        animation: ${animationFirstLine} 1.5s infinite ease-out;
    }

    &:after {
        content: '';
        position: absolute;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.brand};
        animation: ${animationSecondLine} 1.5s infinite ease-in;
    }
`;

Loader.defaultProps = {
    absolute: false,
    position: 'top',
};

export default Loader;
